// @ts-ignore
import { PROBLEM_INNER_TYPES } from '@yandex-int/k-common/constants';
import { RobotProblem } from '../robot.types';

export function isRobotProblem(problem: { type: string } | null | undefined): problem is RobotProblem {
    return problem?.type === PROBLEM_INNER_TYPES.ROBOT;
}
